export const findOrderById = (id: string, orders: any[]): any | null => {
  return orders.find((elem) => elem.id === id)
}
